import { render, staticRenderFns } from "./PreCandidatosTab.vue?vue&type=template&id=c8d74f94&scoped=true&"
import script from "./PreCandidatosTab.vue?vue&type=script&lang=js&"
export * from "./PreCandidatosTab.vue?vue&type=script&lang=js&"
import style0 from "./PreCandidatosTab.vue?vue&type=style&index=0&id=c8d74f94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d74f94",
  null
  
)

export default component.exports